/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {LineItemCpmFeesModalComponent} from './line-item-cpm-fees-modal.component';

export interface LineItemCpmFeesModalOptions {
  moneyCurrency: any;
  uiFees: any;
  isAdOps: boolean;
  isPureMarketplace: boolean;
  isAuction: boolean;
  isNew: boolean;
  readOnly?: boolean;
  onSave: (uiFees: any) => Promise<any>;
}

export interface LineItemCpmFeesModalResult {
  saved: boolean;
  uiFees?: any;
  errors?: any[];
}

@Injectable({providedIn: 'root'})
export class LineItemCpmFeesModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: LineItemCpmFeesModalOptions): Promise<LineItemCpmFeesModalResult> {
    return new Promise((resolve) => {
      let settled = false;
      const complete = (result: LineItemCpmFeesModalResult) => {
        if (settled) {
          return;
        }
        settled = true;
        resolve(result);
      };
      const modalRef = this.angularModalService.show(LineItemCpmFeesModalComponent, {
        initialState: {
          ...options,
          uiFees: _.cloneDeep(options.uiFees),
          onComplete: complete
        }
      });
      modalRef.onHide?.subscribe(() => {
        complete({saved: false});
      });
    });
  }
}
